import { createSlice } from "@reduxjs/toolkit";
import { userAuth } from "api/userAuth";

const initialState = {
    userAuthInfo: {},
    loading: false,
    reload: false,
    organisation_id: '',
    organisationDetails: {}
};

export const loggedInUserInfo = createSlice({
    name: "loggedInUserInfo",
    initialState,
    reducers: {
        userAuthInfo: (state, action) => {
            state.userAuthInfo = action.payload
        },
        storeOrganisationIdReducer: (state, action) => {
            state.organisation_id = action.payload.organisation_id
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(userAuth.pending, (state, action) => {
            state.loading = true;
        })
        .addCase(userAuth.fulfilled, (state, action) => {
            state.userAuthInfo = { ...state.userAuthInfo, ...action.payload }
            state.loading = false;
        })
        .addCase(userAuth.rejected, (state, action) => {
            state.error = "rejected";
            state.loading = false;
        })
    }
})
export const { userAuthInfo, storeOrganisationIdReducer } = loggedInUserInfo.actions;

export default loggedInUserInfo.reducer;

